(function () {
  'use strict';

  function sync() {
    if (!(window.innerWidth >= 1024)) return;
    const target = document.querySelector('.product__info-wrapper')
      || document.querySelector('product-info')
      || document.querySelector('.product__info-container');
    const gallery = document.getElementById('tee-gallery');
    if (!target || !gallery) return false;
    const h = Math.round(target.getBoundingClientRect().height);
    if (h > 0) gallery.style.height = h + 'px';
    return true;
  }

  function waitForGallery() {
    if (sync()) return;

    const mo = new MutationObserver(function () {
      if (sync()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', function () {
      sync();
      mo.disconnect();
    }, { once: true });
  }

  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    document.addEventListener('DOMContentLoaded', waitForGallery, { once: true });
  } else {
    waitForGallery();
  }
})();
